export const PROGRESS = [
  { key: 'NEW', value: 'New' },
  { key: 'WAITING_FOR_ALLOWED_START', value: 'Waiting' },
  { key: 'READY_TO_START', value: 'Ready to start' },
  { key: 'IN_PROGRESS', value: 'In Progress' },
  { key: 'REWORK_NEEDED', value: 'Rework' },
  { key: 'WAITING_FOR_QUALITY_CONTROL', value: 'In QC' },
  { key: 'INVOICABLE', value: 'Invoice-able' },
  { key: 'INVOICE_SUBMITTED', value: 'Invoice submitted' },
  { key: 'INVOICE_APPROVED', value: 'Invoice approved' },
];

export const FIELDS = {
  ASSIGNED_TO_BRANCH_ID: 'assigned_to_branch_id',
  PROGRESS: 'progress',
  IN_ALL_TAB: 'in_all_tab',
  STATE: 'state',
};

export const PAGE_SIZE = 50;
